import { render, staticRenderFns } from "./Idea_block.vue?vue&type=template&id=8af00e7a"
import script from "./Idea_block.vue?vue&type=script&lang=js"
export * from "./Idea_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports